import React from "react";

const PregaNewsIcon = () => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="40"
      viewBox="0 0 1590.000000 460.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g transform="translate(0.000000,460.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
        <path
          fill="#702f90"
          d="M8680 4591 c0 -22 -104 -625 -145 -839 -116 -616 -296 -1452 -350
-1636 -8 -27 -15 -52 -15 -56 0 -3 64 -5 143 -5 l144 0 22 145 c76 493 296
1627 320 1653 7 7 499 -758 721 -1123 109 -179 404 -688 412 -710 2 -8 24 -8
74 1 51 8 88 8 139 0 38 -6 72 -7 76 -3 3 4 23 111 44 237 90 556 279 1488
421 2074 29 124 52 226 51 227 -1 1 -27 -2 -57 -8 -51 -9 -170 -5 -203 8 -11
4 -16 -6 -21 -43 -53 -374 -311 -1681 -345 -1740 -6 -11 -18 0 -53 49 -222
314 -809 1279 -1024 1685 l-48 93 -41 -8 c-51 -9 -178 -9 -227 0 -21 4 -38 3
-38 -1z"
        />
        <path
          fill="#702f90"
          d="M510 4478 c-20 -133 -145 -815 -190 -1033 -88 -427 -269 -1219 -315
-1375 -4 -13 30 -15 269 -15 l273 0 22 130 c27 157 154 792 179 889 l17 70 60
-5 c33 -2 139 -3 235 -3 153 2 188 5 275 28 341 88 545 313 586 646 22 179 -7
373 -72 487 -60 105 -183 191 -334 235 -76 22 -92 23 -345 19 -440 -6 -482 -6
-566 2 l-82 7 -12 -82z m740 -155 c67 -30 115 -89 141 -174 19 -64 21 -87 16
-208 -9 -227 -61 -367 -181 -487 -55 -55 -85 -76 -131 -94 -73 -27 -160 -39
-237 -32 -49 4 -58 8 -58 24 0 22 149 770 181 907 l21 94 102 -5 c72 -3 114
-10 146 -25z"
        />
        <path
          fill="#702f90"
          d="M15686 4039 c-81 -64 -74 -209 13 -254 128 -66 250 85 173 216 -34
59 -133 79 -186 38z m132 -25 c12 -8 29 -28 37 -44 40 -77 -12 -170 -93 -170
-48 0 -71 16 -93 65 -23 53 -17 94 21 135 22 23 37 30 67 30 21 0 49 -7 61
-16z"
        />
        <path
          fill="#702f90"
          d="M2829 3837 c-134 -30 -279 -160 -383 -342 -25 -44 -46 -77 -46 -73 0
9 69 348 76 369 4 14 -2 15 -53 7 -32 -6 -133 -8 -226 -5 -165 5 -167 4 -172
-17 -2 -11 -16 -95 -30 -186 -56 -357 -167 -883 -278 -1325 l-52 -210 247 0
c137 0 248 2 248 5 0 14 94 541 116 650 38 191 89 382 120 447 15 32 52 83 81
115 70 72 131 100 239 106 72 4 88 1 142 -23 33 -15 65 -24 71 -21 5 4 12 32
16 64 14 124 38 231 71 313 19 48 34 89 34 92 0 4 -13 13 -29 22 -42 21 -127
26 -192 12z"
        />
        <path
          fill="#702f90"
          d="M3707 3840 c-435 -54 -751 -432 -783 -938 -24 -370 142 -689 421
-813 102 -45 193 -61 350 -62 223 -2 358 26 473 96 43 26 54 38 63 72 10 39
50 162 64 197 5 13 0 21 -18 29 -23 11 -31 7 -84 -38 -77 -66 -112 -86 -208
-119 -67 -23 -97 -28 -180 -28 -123 1 -196 25 -265 90 -100 93 -134 201 -134
419 0 83 4 157 9 165 7 11 93 12 521 7 l512 -6 5 22 c3 12 11 77 18 144 19
198 -11 362 -89 492 -78 129 -190 213 -333 250 -90 23 -248 33 -342 21z m232
-180 c71 -36 111 -137 111 -280 0 -91 -17 -239 -31 -277 l-9 -23 -278 0 c-153
0 -281 2 -284 5 -14 14 65 283 109 375 41 86 120 174 178 201 55 26 154 25
204 -1z"
        />
        <path
          fill="#702f90"
          d="M5165 3839 c-261 -40 -479 -206 -555 -420 -27 -79 -38 -247 -21 -331
27 -128 111 -238 235 -308 31 -18 55 -37 54 -42 -2 -6 -32 -21 -67 -34 -234
-88 -344 -313 -243 -497 23 -43 91 -108 124 -119 23 -8 -3 -26 -47 -32 -126
-19 -279 -139 -345 -271 -34 -69 -35 -72 -35 -195 0 -115 2 -130 27 -182 50
-107 150 -193 283 -243 132 -50 203 -60 420 -59 188 0 205 2 288 27 356 110
588 382 605 712 8 159 -30 275 -119 364 -91 91 -171 113 -489 136 -259 18
-312 28 -352 64 -60 54 -42 177 36 235 25 19 45 21 264 27 260 7 331 19 458
80 142 67 250 183 302 322 67 178 45 369 -59 526 l-23 34 146 -5 145 -6 6 67
c3 36 9 77 13 90 7 22 5 23 -22 18 -16 -4 -123 -9 -239 -13 l-210 -6 -125 32
c-104 27 -148 33 -260 35 -74 2 -162 0 -195 -6z m277 -139 c39 -11 92 -64 109
-109 26 -65 31 -143 19 -254 -27 -251 -120 -451 -233 -506 -62 -30 -162 -29
-208 2 -75 51 -107 171 -89 335 13 118 31 198 65 287 75 200 192 285 337 245z
m-187 -1725 c149 -31 231 -88 256 -177 18 -65 13 -184 -10 -250 -67 -192 -235
-291 -491 -290 -208 0 -342 69 -409 211 -23 50 -26 68 -26 166 0 98 3 116 26
166 46 97 123 166 214 190 49 14 351 2 440 -16z"
        />
        <path
          fill="#702f90"
          d="M11277 3840 c-150 -19 -274 -71 -407 -171 -433 -327 -508 -1110 -139
-1454 188 -176 480 -234 820 -165 91 19 224 80 240 110 4 8 22 61 39 118 17
57 34 110 37 117 3 9 -5 19 -21 26 -23 11 -29 8 -76 -34 -113 -102 -248 -152
-400 -151 -205 3 -322 97 -377 304 -18 68 -23 311 -8 359 l7 24 514 -6 c478
-6 513 -5 518 11 14 48 28 254 23 325 -23 297 -179 502 -429 566 -89 23 -248
33 -341 21z m252 -189 c20 -14 44 -47 60 -80 24 -53 26 -65 26 -206 0 -87 -6
-178 -14 -217 l-13 -68 -284 0 -284 0 0 23 c0 35 57 240 87 309 37 88 82 156
132 201 63 56 94 68 181 65 61 -2 81 -8 109 -27z"
        />
        <path
          fill="#702f90"
          d="M6707 3824 c-103 -18 -212 -55 -314 -105 l-81 -40 -6 -72 c-4 -40 -9
-89 -12 -109 -7 -45 1 -47 47 -12 50 37 146 85 204 100 66 18 189 18 251 -1
100 -30 168 -117 180 -231 7 -71 -9 -170 -33 -197 -34 -37 -76 -48 -305 -82
-127 -19 -265 -44 -307 -55 -151 -42 -257 -122 -327 -246 -59 -106 -77 -173
-78 -299 -1 -212 73 -351 230 -429 164 -81 429 -53 563 60 18 15 54 58 80 95
l48 68 12 -42 c29 -99 93 -167 186 -197 48 -16 205 -17 260 -1 22 6 63 24 92
41 l52 30 -16 46 c-11 33 -18 43 -26 35 -18 -18 -82 -13 -101 8 -9 10 -22 43
-28 73 -15 74 -1 172 93 623 69 334 72 357 73 490 1 124 -2 147 -23 198 -50
125 -174 218 -334 251 -94 20 -273 20 -380 0z m217 -891 c-33 -193 -86 -439
-103 -484 -30 -79 -77 -146 -124 -177 -35 -23 -51 -27 -113 -27 -58 0 -78 4
-100 21 -73 54 -100 192 -70 345 44 215 122 284 384 339 131 28 134 28 126
-17z"
        />
        <path
          fill="#702f90"
          d="M14945 3824 c-79 -19 -107 -30 -186 -75 -178 -102 -286 -282 -296
-495 -12 -241 69 -371 327 -523 252 -149 309 -196 330 -269 24 -87 5 -150 -65
-219 -67 -65 -133 -88 -239 -81 -160 10 -314 137 -341 281 -7 34 -10 37 -41
37 -30 0 -34 -3 -39 -37 -13 -72 -54 -230 -74 -280 l-20 -51 71 -31 c130 -58
223 -76 403 -75 186 1 268 18 400 83 98 49 169 110 223 193 72 111 86 162 86
323 0 192 -13 227 -138 350 -62 61 -119 106 -176 139 -353 202 -380 227 -380
346 0 89 51 163 139 204 67 30 217 30 283 -1 94 -43 160 -125 189 -235 13 -46
15 -48 49 -48 l37 0 21 111 c12 61 35 144 51 185 l29 75 -35 14 c-88 37 -184
68 -251 81 -93 18 -278 17 -357 -2z"
        />
        <path
          fill="#702f90"
          d="M12090 3802 c0 -4 9 -86 20 -182 29 -260 58 -568 75 -810 17 -242 45
-700 45 -733 0 -22 2 -22 189 -22 l188 0 159 324 c87 178 218 434 290 569
l132 245 6 -44 c10 -76 76 -1019 76 -1079 0 -13 26 -15 188 -16 l188 -1 152
301 c232 460 387 742 669 1214 73 123 133 225 133 227 0 1 -46 1 -102 -2 -57
-3 -123 0 -146 5 l-44 10 -20 -46 c-139 -318 -555 -1140 -604 -1192 -12 -12
-14 -10 -14 16 0 17 -4 87 -10 155 -13 167 -38 629 -46 871 l-7 196 -36 -6
c-46 -9 -235 -9 -282 0 l-36 6 -73 -161 c-86 -191 -407 -841 -481 -977 -29
-52 -54 -90 -55 -85 -5 16 -52 516 -64 675 -6 80 -14 236 -18 345 l-7 199 -50
-4 c-77 -8 -346 -6 -382 2 -18 4 -33 4 -33 0z"
        />
        <path
          fill="#702f90"
          d="M11730 1571 c0 -11 -3 -26 -6 -35 -4 -12 0 -16 16 -16 16 0 20 -5 16
-17 -2 -10 -12 -52 -21 -94 l-16 -76 -39 13 c-85 29 -207 -31 -266 -131 -26
-45 -94 -333 -94 -400 0 -48 21 -94 59 -129 43 -41 133 -49 188 -16 23 14 39
18 41 11 2 -6 30 -11 67 -11 48 0 64 4 69 16 11 28 6 54 -9 54 -8 0 -15 3 -15
7 0 6 142 678 170 806 l8 37 -84 0 c-76 0 -84 -2 -84 -19z m-57 -309 c9 -8 17
-29 17 -46 0 -43 -80 -405 -97 -438 -31 -62 -109 -76 -145 -27 -19 26 -19 26
27 244 45 218 52 236 90 265 40 31 73 31 108 2z"
        />
        <path
          fill="#702f90"
          d="M9955 1548 c-52 -26 -101 -73 -130 -123 -17 -28 -41 -121 -80 -305
-63 -294 -66 -343 -24 -404 37 -55 74 -70 153 -64 l68 6 -7 -37 c-8 -49 -34
-82 -81 -106 -21 -11 -40 -20 -41 -21 -2 0 -6 -15 -9 -33 l-7 -32 39 6 c86 16
171 81 209 161 8 17 36 132 62 255 44 203 50 224 70 227 15 2 22 12 25 33 l5
29 -103 0 -102 0 -4 -30 c-4 -24 -1 -30 14 -30 10 0 18 -4 18 -8 0 -7 -47
-230 -65 -308 -10 -44 -109 -60 -145 -24 -11 11 -20 29 -20 40 0 37 132 634
146 662 33 64 111 78 165 30 27 -24 33 -37 37 -85 4 -54 6 -57 32 -57 26 0 29
4 44 72 9 40 19 90 23 110 5 37 5 38 -26 38 -21 0 -31 -5 -31 -15 0 -20 -3
-19 -46 10 -48 32 -130 34 -189 3z"
        />
        <path
          fill="#702f90"
          d="M6556 1518 c-9 -33 -8 -35 14 -41 11 -3 18 -11 15 -19 -2 -7 -36
-164 -75 -348 -84 -397 -77 -370 -100 -370 -19 0 -30 -19 -30 -51 0 -18 6 -20
73 -17 l72 3 3 33 c2 24 -1 32 -12 32 -9 0 -16 3 -16 8 -1 21 126 602 131 602
3 0 9 -91 13 -202 3 -112 9 -265 13 -341 l6 -138 49 3 49 3 156 338 c86 185
158 336 160 334 3 -4 -111 -551 -123 -589 -3 -10 -14 -18 -24 -18 -10 0 -20
-10 -24 -22 -13 -49 -12 -49 97 -46 l102 3 3 33 c2 24 -1 32 -12 32 -9 0 -16
2 -16 4 0 5 110 523 138 651 15 67 21 80 39 83 15 2 22 12 25 33 l5 29 -128 0
c-123 0 -127 -1 -133 -22 -9 -35 -8 -38 15 -38 13 0 19 -5 16 -12 -16 -41
-261 -564 -267 -571 -4 -5 -12 105 -16 245 -12 351 -13 332 12 336 19 3 33 26
34 55 0 4 -58 7 -129 7 -125 0 -129 -1 -135 -22z"
        />
        <path
          fill="#702f90"
          d="M12265 1525 c-3 -8 -7 -22 -10 -30 -3 -10 2 -15 15 -15 11 0 20 -3
20 -7 0 -5 -35 -171 -77 -370 -66 -310 -79 -363 -94 -363 -20 0 -24 -4 -33
-42 l-6 -28 75 0 c67 0 75 2 75 19 0 11 3 26 6 35 4 12 0 16 -16 16 -16 0 -20
5 -16 18 3 9 33 147 66 307 34 159 62 291 64 292 3 4 14 -101 47 -450 l23
-238 91 3 90 3 3 33 c2 24 -1 32 -13 32 -19 0 -25 -38 68 400 66 308 74 335
93 338 16 2 23 12 26 33 l5 29 -74 0 c-56 0 -73 -3 -73 -14 0 -8 -3 -21 -6
-29 -3 -9 3 -16 17 -20 12 -3 20 -11 17 -19 -3 -7 -34 -148 -69 -313 -74 -349
-64 -358 -105 93 l-28 302 -88 0 c-70 0 -90 -3 -93 -15z"
        />
        <path
          fill="#702f90"
          d="M7468 1341 c-66 -22 -139 -85 -173 -151 -26 -50 -88 -358 -80 -399 9
-49 42 -99 79 -122 45 -28 130 -25 189 5 36 18 47 20 47 9 0 -10 10 -13 33
-11 l32 3 21 103 22 102 -32 0 c-27 0 -33 -5 -49 -45 -22 -53 -73 -100 -122
-114 -60 -16 -105 11 -105 65 0 30 23 153 36 196 5 15 23 18 152 20 l147 3 11
50 c7 28 13 80 13 116 1 71 -18 113 -69 151 -29 21 -112 31 -152 19z m93 -82
c19 -19 21 -29 16 -79 -4 -31 -11 -69 -16 -84 -10 -25 -13 -26 -92 -26 l-81 0
7 45 c11 78 30 119 65 143 41 28 74 28 101 1z"
        />
        <path
          fill="#702f90"
          d="M7965 1334 c-22 -8 -44 -19 -49 -24 -15 -15 -26 -12 -26 5 0 10 -10
15 -30 15 -23 0 -31 -5 -35 -22 -3 -13 -13 -62 -24 -110 l-19 -88 32 0 c28 0
34 5 45 36 26 73 102 134 166 134 14 0 37 -11 52 -26 22 -22 24 -30 18 -71
-11 -73 -11 -73 -52 -57 -103 43 -256 -59 -298 -198 -48 -162 16 -278 153
-278 36 0 59 7 86 25 27 18 36 21 36 10 0 -12 14 -15 64 -15 58 0 64 2 70 23
9 35 7 47 -9 47 -20 0 -20 2 25 219 22 105 40 206 40 224 0 56 -39 119 -90
145 -50 25 -97 27 -155 6z m62 -286 c29 -27 29 -60 3 -175 -25 -104 -40 -130
-86 -149 -30 -13 -38 -13 -64 1 -42 22 -45 50 -20 162 28 121 42 151 83 168
44 19 57 18 84 -7z"
        />
        <path
          fill="#702f90"
          d="M8569 1341 c-14 -5 -38 -16 -52 -26 -24 -16 -27 -16 -27 -1 0 13 -12
16 -64 16 -58 0 -64 -2 -70 -22 -9 -36 -7 -48 9 -48 8 0 15 -6 15 -12 0 -7
-23 -124 -52 -260 -44 -210 -55 -248 -69 -248 -20 0 -24 -4 -33 -43 l-7 -28
103 3 102 3 7 29 c7 23 4 29 -12 33 -10 3 -19 6 -19 7 1 34 103 464 114 482
10 13 33 32 52 42 31 15 38 15 61 2 51 -29 51 -32 -3 -287 -46 -219 -52 -238
-72 -241 -12 -2 -22 -9 -22 -15 0 -7 -3 -22 -6 -35 l-7 -23 104 3 104 3 3 33
c2 24 -1 32 -12 32 -9 0 -16 3 -16 8 0 4 18 92 40 195 48 225 50 277 15 330
-14 20 -38 43 -54 52 -37 19 -99 26 -132 16z"
        />
        <path
          fill="#702f90"
          d="M9110 1341 c-116 -36 -193 -133 -194 -248 -1 -54 2 -65 26 -90 15
-16 68 -46 117 -66 98 -42 124 -63 124 -102 0 -55 -43 -98 -110 -113 -83 -19
-147 31 -148 113 0 44 -1 45 -32 45 -31 0 -32 -2 -43 -57 -6 -32 -16 -74 -21
-93 -5 -19 -9 -41 -9 -47 0 -18 57 -16 64 2 4 12 12 11 42 -10 78 -53 207 -24
287 64 65 72 84 191 39 250 -10 13 -58 42 -107 63 -50 22 -100 49 -112 61 -27
25 -30 72 -7 106 20 28 88 60 129 61 68 0 123 -68 113 -141 -4 -27 -2 -29 28
-29 32 0 33 1 48 68 8 37 18 86 22 110 7 42 6 42 -25 42 -21 0 -31 -5 -31 -15
0 -19 4 -19 -54 10 -49 25 -98 30 -146 16z"
        />
        <path
          fill="#702f90"
          d="M10487 1336 c-62 -23 -129 -82 -159 -140 -20 -40 -88 -334 -88 -384
0 -42 41 -114 79 -139 71 -47 187 -24 264 54 53 52 72 100 107 261 46 218 39
275 -42 335 -34 25 -111 32 -161 13z m101 -76 c29 -27 28 -49 -8 -216 -52
-239 -61 -271 -83 -292 -34 -32 -70 -42 -98 -28 -51 25 -51 44 -3 271 27 123
52 220 63 235 36 50 93 63 129 30z"
        />
        <path
          fill="#702f90"
          d="M11040 1341 c-76 -25 -146 -86 -178 -156 -32 -69 -86 -345 -78 -398
13 -84 77 -137 166 -137 63 0 106 18 159 65 64 58 80 93 116 257 39 171 43
234 19 285 -33 69 -129 109 -204 84z m87 -83 c13 -12 23 -33 23 -47 -1 -51
-87 -419 -104 -446 -21 -32 -72 -56 -100 -45 -11 4 -29 18 -39 31 -17 24 -17
29 28 239 46 219 59 253 106 277 35 18 60 16 86 -9z"
        />
        <path
          fill="#702f90"
          d="M12953 1334 c-55 -20 -126 -84 -152 -137 -26 -54 -81 -312 -81 -380
0 -60 29 -117 76 -147 43 -29 127 -27 190 5 58 29 55 29 48 10 -5 -12 2 -15
29 -15 l34 0 17 88 c10 48 19 95 22 105 4 13 -1 17 -25 17 -26 0 -33 -6 -49
-42 -34 -78 -131 -139 -186 -118 -53 20 -56 53 -21 208 l17 72 147 0 148 0 17
86 c14 70 15 95 6 133 -25 107 -124 155 -237 115z m108 -72 c26 -22 28 -49 10
-134 l-12 -58 -85 0 c-93 0 -90 -3 -74 70 17 72 30 98 64 120 39 25 67 25 97
2z"
        />
        <path
          fill="#702f90"
          d="M14310 1335 c-98 -31 -180 -138 -180 -238 0 -80 19 -103 128 -154
144 -66 164 -92 122 -160 -31 -52 -103 -79 -166 -61 -45 12 -74 58 -74 116 0
43 0 43 -32 40 -32 -3 -33 -4 -49 -78 -9 -41 -19 -88 -23 -103 -6 -26 -5 -27
29 -27 25 0 35 4 35 16 0 12 6 11 32 -8 24 -17 50 -24 98 -26 56 -3 72 0 120
25 91 48 140 130 140 235 0 65 -25 90 -151 152 -83 41 -106 57 -113 78 -24 68
68 147 157 135 62 -8 97 -51 97 -118 l0 -50 32 3 c31 3 32 3 54 103 13 55 23
103 24 108 0 4 -14 7 -31 7 -23 0 -32 -5 -36 -21 l-6 -20 -22 21 c-42 40 -108
48 -185 25z"
        />
        <path
          fill="#702f90"
          d="M13256 1314 c-13 -35 -7 -54 19 -54 14 0 25 -4 25 -9 0 -15 49 -494
55 -538 l6 -43 49 0 49 0 85 163 c47 89 86 158 86 152 0 -5 7 -71 15 -145 8
-74 15 -143 15 -153 0 -15 8 -18 52 -15 l52 3 152 290 151 290 37 3 c20 2 36
9 36 15 0 7 3 22 6 35 6 22 5 22 -84 22 -85 0 -90 -1 -96 -22 -10 -38 -7 -48
14 -48 18 0 8 -26 -83 -201 -57 -110 -108 -201 -113 -202 -9 -2 -42 278 -43
361 -1 35 2 42 18 42 20 0 31 18 31 51 0 18 -8 19 -114 19 -109 0 -114 -1
-120 -22 -10 -39 -7 -48 19 -48 26 0 30 -11 38 -110 4 -40 -4 -60 -66 -179
-39 -74 -72 -131 -73 -125 -2 5 -10 81 -19 169 -9 88 -18 179 -22 203 -5 40
-4 42 21 42 14 0 26 6 26 13 0 6 3 22 6 35 6 22 6 22 -109 22 -95 0 -116 -3
-121 -16z"
        />
        <path
          fill="#702f90"
          d="M11865 465 c-297 -35 -557 -99 -800 -198 -96 -39 -265 -122 -307
-151 -19 -14 -18 -15 23 -26 24 -6 100 -28 169 -48 l126 -38 44 29 c145 95
480 221 715 271 436 91 898 93 1395 5 63 -11 126 -22 140 -25 14 -2 -13 10
-60 26 -192 70 -495 134 -749 160 -139 14 -560 11 -696 -5z"
        />
      </g>
    </svg>
  );
};

export default PregaNewsIcon;
